export interface ExecutiveMetric {
  label: string;
  value: string;
  change: string;
  trend: 'up' | 'down' | 'stable';
}

export interface ExecutiveReport {
  id: string;
  title: string;
  description: string;
  icon: string;
  period: string;
  metrics: ExecutiveMetric[];
}

export const executiveReports: ExecutiveReport[] = [
  {
    id: 'ingresos',
    title: 'Ingresos',
    description: 'Ingresos totales por suscripciones, planes y servicios',
    icon: 'ri-money-dollar-circle-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Total mensual', value: '$ 48,250', change: '+12.4%', trend: 'up' },
      { label: 'Suscripciones', value: '$ 32,800', change: '+8.1%', trend: 'up' },
      { label: 'Servicios extra', value: '$ 15,450', change: '+22.6%', trend: 'up' },
    ],
  },
  {
    id: 'radios',
    title: 'Radios',
    description: 'Crecimiento y estado de las radios en la plataforma',
    icon: 'ri-radio-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Radios activas', value: '847', change: '+34', trend: 'up' },
      { label: 'Nuevas este mes', value: '28', change: '+5', trend: 'up' },
      { label: 'Tasa de retención', value: '94.2%', change: '+1.1%', trend: 'up' },
    ],
  },
  {
    id: 'oyentes',
    title: 'Oyentes',
    description: 'Audiencia total y comportamiento de escucha',
    icon: 'ri-user-voice-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Oyentes activos', value: '142,800', change: '+18.3%', trend: 'up' },
      { label: 'Nuevos oyentes', value: '8,420', change: '+12.7%', trend: 'up' },
      { label: 'Horas de escucha', value: '1.2M', change: '+9.5%', trend: 'up' },
    ],
  },
  {
    id: 'publicidad',
    title: 'Publicidad',
    description: 'Ingresos y rendimiento de los anuncios en la plataforma',
    icon: 'ri-advertisement-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Ingresos por anuncios', value: '$ 22,400', change: '+15.8%', trend: 'up' },
      { label: 'Campañas activas', value: '64', change: '-3', trend: 'down' },
      { label: 'Impresiones', value: '2.8M', change: '+24.1%', trend: 'up' },
    ],
  },
  {
    id: 'marketplace',
    title: 'Marketplace',
    description: 'Actividad en el marketplace de anuncios entre radios y anunciantes',
    icon: 'ri-store-2-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Transacciones', value: '312', change: '+22', trend: 'up' },
      { label: 'Volumen total', value: '$ 18,700', change: '+31.2%', trend: 'up' },
      { label: 'Radios participantes', value: '156', change: '+9', trend: 'up' },
    ],
  },
  {
    id: 'revenue-share',
    title: 'Revenue Share',
    description: 'Distribución de ingresos compartidos con las radios',
    icon: 'ri-percent-line',
    period: 'Junio 2026',
    metrics: [
      { label: 'Total compartido', value: '$ 14,320', change: '+19.6%', trend: 'up' },
      { label: 'Radios beneficiadas', value: '612', change: '+28', trend: 'up' },
      { label: 'Promedio por radio', value: '$ 23.40', change: '+7.2%', trend: 'up' },
    ],
  },
];